/**
 * btnClick - Aids with button focus styles
 */
export function btnClick() {
  document.querySelector('body').addEventListener('click', function(e){
    if (e.target.className && typeof e.target.className === 'string') {
      if (e.target.className.indexOf('btn') > -1) {
        if (e.target.className.indexOf('btn--clicked') === -1) {
          e.target.className += ' btn--clicked';
        }
  
        e.target.addEventListener('blur', function(e){
          e.target.className = e.target.className.replace(' btn--clicked', '');
        })
      }
    }
  });
}

/**
 * Selector for any HTML element that can receive keyboard focus
 * 
 * @exports
 */
export const focusable = `a[href]:not([tabindex='-1']),area[href]:not([tabindex='-1']),
input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
textarea:not([disabled]):not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),
iframe:not([tabindex='-1']),[tabindex]:not([tabindex='-1'])`;

/**
 * parseSeconds - Takes seconds and returns it as hh:mm:ss
 * @param {string} seconds
 */
export function parseSeconds(seconds) {
  return new Date(seconds * 1000).toISOString().substr(11, 8);
}

/**
 * parseMinutes - Takes minutes and returns it as hh:mm
 */
export function parseMinutes(minutes) {
  return new Date(minutes * 60000).toISOString().substr(11, 5);
}

/**
 * readableMinutes - Takes minutes and returns it as # hours and # minutes
 */
export function readableMinutes(minutes, labels) {
  const hr = Math.floor(minutes / 60);
  let lbls = labels;

  if (!labels) {
    lbls = {
      hour: 'hour',
      hours: 'hours',
      minute: 'minute',
      minutes: 'minutes'
    };
  }

  let hrLabel = lbls.hours;

  if (hr === 1) {
    hrLabel = lbls.hour;
  }

  const min = minutes % 60;
  let minLabel = lbls.minutes;

  if (min === 1) {
    minLabel = lbls.minute;
  }

  let string = '';

  if (hr) {
    string = string + `${hr} ${hrLabel}`;
  }

  if (min) {
    string = string + `${hr ? ' ' : ''}${min} ${minLabel}`
  }

  return string;
}

/**
 * Get data out of sessionStorage and fall back to cookies
 * 
 * @exports
 * @function getData
 * @param {string} name
 * @return {string}
 */
export function getData(name) {
  try {
    return sessionStorage.getItem(name);
  } catch (error) {
    const match = document.cookie.match(new RegExp(name + '=([^;]+)'));

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }
}

/**
 * getParam - Get query params from a string
 * @param {string} name
 * @param {string} url
 */
export function getParam(name, url) {
  if (!url) url = window.location.href;

  name = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  let results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * Get a given URL segment
 * 
 * @exports
 * @function getUrlSegment
 * @param {integer} segment
 * @param {pathname} [pathname]
 * @returns {string}
 */
export function getUrlSegment(segment, pathname) {
  if (!pathname) {
    pathname = window.location.pathname;
  }

  let pathArray = pathname.split('/');

  if (pathArray[0] === '') {
    pathArray.splice(0, 1);
  }

  return pathArray[segment - 1];
}

/**
 * Store data in sessionStorage and fall back to cookies
 * 
 * @exports
 * @function storeData
 * @param {string} name
 * @param {string} data
 */
export function storeData(name, data) {
  try {
    sessionStorage.setItem(name, data);
  } catch (error) {
    document.cookie = name + '=' + data + '; expires=0; path=/';
  }
}